import type { party_enum } from '@vrplatform/graphql';
import { getTransactionLineType } from '@vrplatform/ui-common';

export const getDepositReservationLineParty = (
  item: Parameters<typeof getTransactionLineType>[0]
) => {
  const type = getTransactionLineType(item);

  // When converting non-reservation to reservation deposit lines, setting correct party
  const parties: Record<NonNullable<typeof type>, party_enum> = {
    coHostPayout: 'owners',
    refund: 'owners',
    payment: 'owners',
    channelFee: 'manager',
    merchantFee: 'manager',
    vat: 'manager',
    reserve: 'owners',
  };

  return type ? parties[type] : null;
};
